import { FILTER_SHOW_ALL } from '../constants/filtering';
import { get } from 'lodash';

export const getPostTypeFilter = state => get(state, 'filtering.postType', FILTER_SHOW_ALL);

export const getCategoryFilter = state => get(state, 'filtering.categorySlug', '');
